import React from 'react';
import { Label } from '../Label/Label';
import { Tooltip } from '../Tooltip/Tooltip';
import { useLastWord } from '../utils/useLastWord';
import { FontSizeType } from 'common-react';

import useStyles from './LabelWithTooltip.style'

export interface LabelWithTooltipProps {
  customZIndex?: number;
  labelText?: string;
  preTitle?: string;
  title?: string | React.ReactNode;
  size?: FontSizeType;
  color?: 'dark' | 'graphite';
  className?: string;
  tooltipClassName?: string;
  testId?: string;
}

const LabelWithTooltip: React.FC<LabelWithTooltipProps> = ({
  customZIndex,
  labelText,
  preTitle,
  title,
  size = 's',
  color = 'graphite',
  className,
  tooltipClassName,
  testId,
}) => {
  const c = useStyles({});
  const parts = useLastWord(labelText);

  return (
    <Label size={size} color={color} className={className} data-testid={testId}>
      <span>
        {parts.before && `${parts.before} `}
        {parts.last ? (
          <span className={c.noWrap}>
            {parts.last}
            {(preTitle || title) && (
              <Tooltip className={tooltipClassName ?? c.tooltip} preTitle={preTitle} title={title} customZIndex={customZIndex} />
            )}
          </span>
        ) : null}
      </span>
    </Label>
  );
};

export { LabelWithTooltip };
